import lutInstant from "./basic_lut_assets/lut_instant.png"
import lutProcess from "./basic_lut_assets/lut_process.png"
import lutTonal from "./basic_lut_assets/lut_tonal.png"
import lutTransfer from "./basic_lut_assets/lut_transfer.png"
import lutChroma from "./basic_lut_assets/lut_chroma.png"
import lutFade from "./basic_lut_assets/lut_fade.png"
import lutMono from "./basic_lut_assets/lut_mono.png"
import lutNoir from "./basic_lut_assets/lut_noir.png"

import { ColorMapFilter } from 'pixi-filters'
import { Filter, MIPMAP_MODES, SCALE_MODES, Texture } from '@pixi/core'
import { SwapRGBFilter } from '@scenes/engine/utils/PixijsFilters/SwapRGB/SwapRGBFilter'
import { VerticalColorMapFilter } from '@scenes/engine/utils/PixijsFilters/VerticalColorMap/VerticalColorMapFilter'


class BasicFilterFactory
{
    private static textureCache: Map<string, Texture> = new Map(); // Cache textures by URL
    type: FilterPresetType

    constructor(type: FilterPresetType)
    {
        this.type = type;
    }

    async geFilter(intensity: number): Promise<Filter> {
        const lutUrl = this.getLUTForFilterType();
        if (!lutUrl) {
            return new Filter();
        }

        // Cache the texture, not the filter instance
        let lutTexture = BasicFilterFactory.textureCache.get(lutUrl);
        if (!lutTexture) {
            lutTexture = await Texture.fromURL(lutUrl);
            BasicFilterFactory.textureCache.set(lutUrl, lutTexture);
        }
        
        if (!lutTexture) {
            return new Filter(); 
        }

        // Always create a new filter instance to avoid race conditions with shared state (mix/intensity)
        let filter = new VerticalColorMapFilter(lutTexture, false, intensity);
        return filter;
    }

    private getLUTForFilterType(): any | null {
      switch (this.type) {
          case FilterPresetType.transfer:
            return lutTransfer;
          case FilterPresetType.process:
            return lutProcess;
          case FilterPresetType.instant:
            return lutInstant;
          case FilterPresetType.tonal:
            return lutTonal;
          case FilterPresetType.chrome:
            return lutChroma;
          case FilterPresetType.fade:
            return lutFade;
          case FilterPresetType.monochrome:
            return lutMono;
          case FilterPresetType.noir:
            return lutNoir;
          default:
            return null;
      }
    }
}

enum FilterPresetType {
  default,
  chrome,
  fade,
  monochrome,
  noir,
  transfer,
  process,
  instant,
  tonal
}


export { BasicFilterFactory, FilterPresetType };